import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { Spinner } from "../components/common";
import { Field } from "./Login";
import { api, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen w-full flex justify-center bg-background">
      <div className="w-full max-w-md bg-mesh min-h-screen px-6 pt-10 pb-10 flex flex-col">
        <Logo size={36} />
        {sent ? (
          <div className="mt-16 text-center animate-fade-up">
            <div className="mx-auto mb-5 grid place-items-center w-16 h-16 rounded-2xl bg-success/10 text-success">
              <CheckCircle2 size={30} />
            </div>
            <h1 className="font-display text-3xl font-light tracking-tight">Check your email</h1>
            <p className="text-muted-foreground mt-3 max-w-xs mx-auto">
              If that email is registered, we've sent a password reset link. It expires in 1 hour.
            </p>
            <Link to="/login" data-testid="back-to-signin-link" className="inline-block mt-8 text-primary font-semibold">Back to sign in</Link>
          </div>
        ) : (
          <>
            <div className="mt-10 animate-fade-up">
              <h1 className="font-display text-4xl font-light tracking-tighter">Reset password</h1>
              <p className="text-muted-foreground mt-2">Enter your email and we'll send you a reset link.</p>
            </div>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <Field icon={Mail} type="email" required placeholder="Email address" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button type="submit" disabled={busy} data-testid="forgot-submit-btn"
                className="w-full h-14 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center shadow-[0_12px_32px_rgba(75,35,204,0.3)] transition-transform duration-200 active:scale-[0.98] disabled:opacity-60">
                {busy ? <Spinner className="w-5 h-5" /> : "Send reset link"}
              </button>
            </form>
            <Link to="/login" data-testid="back-to-signin-link" className="text-center text-sm text-primary font-semibold mt-auto pt-8">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
